<template>
    <div>
        <v-footer color="background lighten-1"
                  padless>
            <v-row justify="center"
                   no-gutters>
                <v-btn v-for="link in links"
                       :key="link.name"
                       text
                       :to="link.to"
                       rounded
                       class="my-2">
                    {{ link.name }}
                </v-btn>
                <v-col class="background lighten-1 py-4 text-center"
                       cols="12">
                    &#169; {{ new Date().getFullYear() }} - <strong>Powered by TechOps</strong>
                </v-col>
            </v-row>
        </v-footer>
    </div>
</template>

<script>
    export default {
        data: function () {
            return {
                links: [
                    { name: 'Home', to: '/' },
                    { name: 'Help', to: '/help' },
                    { name: 'My Charts', to: '/mycharts' },
                    { name: 'Chart Builder', to: '/chartbuilder' },
                ],
            }
        }
    }
</script>
